module.exports = __webpack_public_path__ + "img/icon_advantage_tuandui@2x.73683cce.png";